import React from "react";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { LinkButton } from "./linkButton";
import { IconButton } from "@mui/material";

type EditButtonProps = {
  to: string;
};

export function Edit({ to }: EditButtonProps) {
  return (
    <LinkButton to={`${to}`} title={"Editar"}>
      <IconButton>
        <EditOutlinedIcon color="secondary" />
      </IconButton>
    </LinkButton>
  );
}
